import React from 'react'
import { MotionContainer, varFade } from 'src/components/animate';
import { styled } from '@mui/material/styles';
import { m } from 'framer-motion';
import { Button, Box, Link, Container, Typography, Stack } from '@mui/material';
import { Card, CardContent, Grid } from '@mui/material';
import { PATH_DASHBOARD, PATH_PAGE } from 'src/routes/paths';
import NextLink from 'next/link';

const RootStyle = styled(m.div)(({ theme }) => ({
    position: 'relative',
    marginBottom: 0,
    paddingBottom: '5%',
    background: 'linear-gradient(104.03deg, #0C103A 100.91%, #3564CA 124.24%)',
    [theme.breakpoints.up('md')]: {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
    },
    [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(2)
    },
}));

const HeroImgStyle = styled(m.img)(({ theme }) => ({
    zIndex: 8,
    width: '49px',
    height: '48px',
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
        width: '49px',
        height: '48px',
    },
}));

const ImageDirection = styled(Box)(({ theme }) => ({
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(3)
}));

const CustomHeaderBox = styled(Box)(({ theme }) => ({
    width: '100%',
    textAlign: 'center',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4)
}));
const CustomHeaderChip = styled(Typography)(({ theme }) => ({
    width: '100%',
    textAlign: 'center',
    color: '#909EAB !important',
    fontWeight: 500,
    fontSize: '20px !important',
    lineHeight: '23.44px !important',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        width: '100%',
        fontSize: '12px !important',
        lineHeight: '14px !important'
    }

}));
const CustomHeaderTypography = styled(Typography)(({ theme }) => ({
    width: '100%',
    textAlign: 'center',
    color: theme.palette.common.white,
    fontSize: '42px !important',
    fontWeight: 700,
    lineHeight: '49.22px !important',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        width: '100%',
        fontSize: '22px !important',
        lineHeight: '26px !important'
    }
}));
const CustomHeaderSubTypography = styled(Typography)(({ theme }) => ({
    width: '55%',
    textAlign: 'center',
    color: theme.palette.common.white,
    fontSize: '16px !important',
    fontWeight: 400,
    lineHeight: '19px !important',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        width: '100%',
        fontSize: '13px !important',
        lineHeight: '15px !important'
    }
}));

const CustomCardSubTypography = styled(Typography)(({ theme }) => ({
    width: '100%',
    textAlign: 'center',
    color: theme.palette.default,
    fontSize: '16px !important',
    fontWeight: 400,
    lineHeight: '19px !important',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        width: '100%',
        fontSize: '14px !important',
        lineHeight: '16px !important'
    }

}));

const CustomCardTypography = styled(Typography)(({ theme }) => ({
    width: '100%',
    textAlign: 'center',
    color: theme.palette.default,
    fontSize: '28px !important',
    fontWeight: 700,
    lineHeight: '33px !important',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        width: '100%',
        fontSize: '18px !important',
        lineHeight: '21px !important',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center'
    }
}));

const CustomCard = styled(Card)(({ theme }) => ({
    width: '100%',
    borderRadius: '18px',
    height: '100%'
}));

const SetAlignment = styled(m.div)(({ theme }) => ({
    width: '100%',
    textAlign: 'center'
}));

const CustomButton = styled(Button)(({ theme }) => ({
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        width: '100%',
        borderRadius: '3px',
        background: theme.palette.common.white,
        color: theme.palette.primary.main
    }
}));


const TrackCardData = [
    {
        id: 1,
        icon: '/icons/home/asset-management.svg',
        link: PATH_PAGE.assetmgmt,
        title: '<p>Asset Management</p>',
        subtitle: 'Easily check in assets to quickly move </br/> assets to designated project, location or individual.'
    },
    {
        id: 2,
        icon: '/icons/home/livestock.svg',
        link: PATH_PAGE.livestockmgmt,
        title: '<p>Livestock Management</p>',
        subtitle: 'Real-time record keeping <br/> makes it easy to manage your herd.'
    },
    {
        id: 3,
        icon: '/icons/home/inventory.svg',
        link: PATH_PAGE.inventmgmt,
        title: '<p>Inventory Management</p>',
        subtitle: 'Manage logistical, maintenance, <br/> warranty, end of life of your inventories.'
    },
    {
        id: 4,
        icon: '/icons/home/resource.svg',
        link: PATH_PAGE.resrcmgmt,
        title: '<p>Resource Management</p>',
        subtitle: 'Visualize and manage every resource <br/> for tactical and strategic capacity.'
    },
    {
        id: 5,
        icon: '/icons/home/fleet.svg',
        link: PATH_PAGE.fleetmgmt,
        title: '<p>Fleet Management</p>',
        subtitle: 'Track vehicles, trailers, and <br/> equipment in real-time. '
    },
    {
        id: 6,
        icon: '/icons/home/facilities.svg',
        link: PATH_PAGE.facimgmt,
        title: '<p>Facilities Management</p>',
        subtitle: 'Streamline processes, increase asset productivity, <br/>  and turn actionable insights into meaningful results.'
    },
    {
        id: 7,
        icon: '/icons/home/toolkit.svg',
        link: PATH_PAGE.toolmgmt,
        title: '<p>Toolkit Management</p>',
        subtitle: 'Manage tracking, get maintenance alerts, calibration alerts <br/>  and damage tracking of your tools and toolkits.'
    },
    {
        id: 8,
        icon: '/icons/home/residential-asset.svg',
        link: PATH_PAGE.residensmgmt,
        title: '<p>Residential Asset Management</p>',
        subtitle: 'Systematic and coordinated activities <br/> through which one can optimally and sustainably <br/> manages their physical assets.'
    }
]

export default function HomeHelp() {
    return (
        <MotionContainer>
            <RootStyle>
                <Container>
                    <Box>
                        <CustomHeaderBox>
                            <m.div variants={varFade().in}>
                                <CustomHeaderChip variant="h2" sx={{ color: 'common.white' }}>
                                    Solutions
                                </CustomHeaderChip>
                                <CustomHeaderTypography>
                                How can ATC help you?
                                </CustomHeaderTypography>
                                <Box sx={{ width: '100%', textAlign: 'center', justifyContent: 'center', display: 'flex', flexWrap: 'wrap' }}>
                                    <CustomHeaderSubTypography variant='body2'>
                                    ATC provides quicker access to information, allowing for faster, well-informed decisions across various domains of industries.
                                    </CustomHeaderSubTypography>
                                </Box>
                            </m.div>
                        </CustomHeaderBox>
                        <Grid container spacing={2}>
                            {TrackCardData && TrackCardData.map((item, index) => (
                                <Grid key={`TrackCardData${index}`} item lg={6} md={6} sm={12} xs={12}>
                                    <NextLink href={item.link} passHref>
                                    <CustomCard sx={{cursor: 'pointer'}}>                                    
                                       <CardContent>
                                            <ImageDirection>
                                                <HeroImgStyle
                                                    alt="hero"
                                                    src={item.icon}
                                                    variants={varFade().inUp}
                                                />
                                            </ImageDirection>
                                            <m.div variants={varFade().inRight}>
                                                <CustomCardTypography variant="h1" dangerouslySetInnerHTML={{ __html: item.title }} sx={{ color: 'default' }} />

                                            </m.div>
                                            <m.div variants={varFade().inRight}>
                                                <CustomCardSubTypography dangerouslySetInnerHTML={{ __html: item.subtitle }} variant="body2" sx={{ color: 'default' }} />
                                            </m.div>
                                        </CardContent>                                        
                                    </CustomCard>
                                    </NextLink>
                                </Grid>
                            ))}
                        </Grid>
                        {/*<SetAlignment variants={varFade().in}>
                            <NextLink href={PATH_DASHBOARD.root} passHref>
                                <CustomButton
                                    size="large"
                                    variant="contained"
                                    sx={{
                                        my: 4,
                                        justifyContent: 'center'
                                    }}
                                >
                                    Register Now
                                </CustomButton>
                            </NextLink>
                                </SetAlignment>*/}
                    </Box>
                </Container>
            </RootStyle>
        </MotionContainer>
    )
}